<h2>Event Attributes</h2>

<div
  class="toolbar actions-bar"
  fxLayout="row"
  fxLayoutAlign="start center"
  fxLayout.lt-md="column"
  fxLayoutAlign.lt-md="start start"
>
  <button
    *ngIf="canEdit()"
    type="button"
    mat-raised-button
    color="accent"
    matTooltip="Add event attribute"
    (click)="addEventAttribute()"
  >
    <mat-icon>add</mat-icon>
    Add Attributes
  </button>

  <button
    type="button"
    mat-stroked-button
    *ngIf="canEdit() && getSelectedSectionRecords().length > 0"
    [matMenuTriggerFor]="menu"
    matTooltip="Actions"
  >
    <mat-icon>more_vert</mat-icon>
    Actions
  </button>
  <mat-menu #menu="matMenu" class="mat-dropdown-menu">
    <button type="button" mat-menu-item (click)="cloneSelectedRecords()">
      <mat-icon>content_copy</mat-icon>
      Clone
    </button>
    <button type="button" mat-menu-item (click)="assignPageToSelectedRecords()">
      <mat-icon>article</mat-icon>
      Assign Page
    </button>
    <button type="button" mat-menu-item (click)="downloadCSV()">
      <mat-icon>file_download</mat-icon>
      Download CSV
    </button>
    <button type="button" mat-menu-item (click)="deleteSelectedRecords()">
      <mat-icon>delete</mat-icon>
      Delete
    </button>
    <button type="button" mat-menu-item *ngIf="getSelectedSectionRecords().length">
      {{ getSelectedSectionRecords().length }} Selected
    </button>
  </mat-menu>

  <mat-form-field appearance="outline" class="mat-form-field-no-padding search-field">
    <mat-icon matPrefix>search</mat-icon>
    <input
      matInput
      type="text"
      (input)="onSearch($event)"
      placeholder="Search attributes..."
      #searchInput
      [formControl]="searchControl"
    />
    <button
      type="button"
      matSuffix
      mat-icon-button
      aria-label="Clear"
      *ngIf="searchInput.value"
      (click)="clearSearch()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </mat-form-field>
</div>

<ng-container *ngIf="viewModel$ | async as viewModel">
  <mat-sidenav-container>

    <mat-sidenav-content>
      <table
        *ngIf="viewModel.attributes.length"
        mat-table
        [dataSource]="viewModel.attributes"
        matSort
        matSortActive="Name"
        matSortDirection="asc"
        matSortDisableClear
        (matSortChange)="onSort($event)"
      >
        <ng-container matColumnDef="select">
          <th class="no-ellipsis" mat-header-cell *matHeaderCellDef [resizeColumn]="true">
            <mat-checkbox
              (change)="$event ? masterToggle() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()"
            >
            </mat-checkbox>
          </th>
          <td class="no-ellipsis" mat-cell *matCellDef="let row">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)"
            >
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="Name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Name" [resizeColumn]="true">
            Name
          </th>
          <td mat-cell *matCellDef="let record">{{ record.Detail?.PrintAttributeName }}</td>
        </ng-container>

        <ng-container matColumnDef="EventTypeName">
          <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">
            Event Type
          </th>
          <td mat-cell *matCellDef="let record">{{ record.EventTypeName || '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="PrintAttributeType">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Attribute Type" [resizeColumn]="true">
            Attribute Type
          </th>
          <td mat-cell *matCellDef="let record">
            <span
              class="attr-type-pill"
              [ngClass]="'print-attr-tone--' + attrType"
              *ngIf="record.Detail?.PrintAttributeType as attrType"
            >
              {{ getPrintAttributeTypeLabel(attrType) }}
            </span>
            <span *ngIf="!record.Detail?.PrintAttributeType">-</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="Description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Description" [resizeColumn]="true">
            Description
          </th>
          <td mat-cell *matCellDef="let record">{{ record.Detail?.Description || '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="Page">
          <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">Page</th>
          <td mat-cell *matCellDef="let record">{{ record.PrintPageName || '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="Position">
          <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">Position</th>
          <td mat-cell *matCellDef="let record">{{ record['Position'] || '-' }}</td>
        </ng-container>

        <ng-container matColumnDef="Versions">
          <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">Version(s)</th>
          <td mat-cell *matCellDef="let record">{{ record.VersionNames }}</td>
        </ng-container>

        <ng-container matColumnDef="Source">
          <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">Source</th>
          <td mat-cell *matCellDef="let record">{{ record.Detail?.EventOnlyAttribute ? 'Event only' : 'Global' }}</td>
        </ng-container>

        <ng-container *ngIf="canEdit()" matColumnDef="Actions">
          <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">Actions</th>
          <td mat-cell *matCellDef="let record">
            <button
              type="button"
              mat-icon-button
              (click)="editEventAttribute(record)"
            >
              <mat-icon>edit</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <table *ngIf="!viewModel.attributes.length">
        <tr>
          <td class="no-records" [attr.colspan]="displayedColumns.length">
            <h2>No Records Found</h2>
          </td>
        </tr>
      </table>

      <mat-paginator
        *ngIf="viewModel.attributes.length"
        [pageSizeOptions]="[5, 10, 20, 50, 100]"
        [pageSize]="viewModel.page.pageSize"
        [length]="viewModel.totalRecords"
        (page)="onPage($event)"
      >
      </mat-paginator>
    </mat-sidenav-content>
  </mat-sidenav-container>
</ng-container>

